import template from './CreateSubFlowModalView.html';
import controller from './CreateSubFlowModalController';
export default (params) => {
    return {
        template,
        controller,
        controllerAs: '$ctrl',
        ...params,
        inputs: {
            ...params.inputs,
            body: params.body || '',
            modalClass: params.modalClass || '',
            modalSizeClass: params.modalSizeClass || '',
            bodyClass: params.bodyClass || '',
            bodyContentClass: params.bodyContentClass || '',
            footerClass: params.footerClass || '',
            footerContentClass: params.footerContentClass || '',
            size: params.size || 'sm',
            confirm: params.confirm,
            whatIsSubflow: params.whatIsSubflow,
            action: params.action,
            shortName: params.shortName,
        },
    };
};
